<template>
  <div class="page-layout">
    <div class="columns is-align-items-center margin-0">
      <div class="column is-3-mobile is-5-desktop is-5-widescree p-y-0 p-x-0">
        <div class="level">
          <div class="level-left">
            <div class="page-layout-head">Review invites</div>
          </div>
        </div>
      </div>
      <div class="column p-y-0 p-x-0 is-flex is-align-items-center header-filters">
        <a v-if="isActiveTab('ReviewInviteGoogleReviews')"
           class="about-feature"
           target="_blank"
           data-track="Google Reviews - About this feature button"
           href="https://intercom.help/hellopeter/en/articles/4423824-google-review-invites">
          <img src="/static/img/dummy-help.png"/>
          <span class="abt_section">About this feature</span>
        </a>
        <a v-else class="about-feature" target="_blank"
           href="https://intercom.help/hellopeter/en/articles/4228174-review-invites">
          <img src="/static/img/dummy-help.png"/>
          <span class="abt_section">About this feature</span>
        </a>
        <date-select-filter
          class="custom-dropdown"
          :reviews_start_date="filters.dateFilter.reviews_start_date"
          :filter_items="filters.dateFilter.props"
          :styleProp="filters.dateFilter.styleProp"
          @onDateChange="handleDateChange"
          data-track="Review Analytics change date"
          v-if="isDatepickerAllowed"
        />
        <a
          :disabled="!isPaidUser"
          :href="isPaidUser ? exportHistoryReviews : `javascript:void(0)`"
          class="button is-hidden-mobile export-button"
          data-track="Review Analytics export"
          v-if="isDatepickerAllowed"
        >EXPORT
        </a>
        <a
          :disabled="!isPaidUser"
          :href="isPaidUser ? exportHistoryReviews : `javascript:void(0)`"
          class="button is-hidden-tablet is-fullwidth export-button"
          data-track="Review Analytics export"
          v-if="isPaidUser ? isDatepickerAllowed : `javascript:void(0)`"
        >EXPORT
        </a>
      </div>
    </div>
    <hr class="page-layout-horizontal-row">
    <div class="columns invite-menu">
      <div class="column is-12 is-paddingless">
        <div class="tabs is-boxed">
          <ul>
            <li :class="{'is-active': isActiveTab('ReviewInviteTemplate')}">
              <router-link to="/collect-reviews/review-invites/template"><span>Email Template</span></router-link>
            </li>
            <li :class="{'is-active': isActiveTab('SMSSetup') || isActiveTab('ReviewInviteSMSSetup')}">
              <router-link to="/collect-reviews/review-invites/SMSSetup"><span>SMS Template</span></router-link>
            </li>
            <li :class="{'is-active': isActiveTab('ReviewInviteGoogleReviews')}">
              <router-link to="/collect-reviews/review-invites/google-reviews"><span>Google Reviews</span></router-link>
            </li>
            <li :class="{'is-active': isActiveTab('ReviewInvites') || isActiveTab('ReviewInviteSends')}">
              <router-link to="/collect-reviews/review-invites/send"><span>Send Invites</span></router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import axios from 'axios'
  import moment from 'moment'
  import misc from '../../mixins/misc.js'
  import {DateSelectFilter} from '@/components'
  import qs from 'qs'

  export default {
    mixins: [misc],
    components: {
      DateSelectFilter
    },
    computed: {
      /**
       * Get link to export review analytics data
       * @return {string}
       */
      exportHistoryReviews () {
        const authToken = qs.stringify({token: this.authToken})
        const url = `/marketing/${this.businessSlug}/export-review-invitation-history?startDate=${this.filters.dateFilter.startDate}&endDate=${this.filters.dateFilter.endDate}&${authToken}`
        return process.env.API_URL + url
      },
      isDatepickerAllowed () {
        return this.showDatepicker.includes(this.$route.name)
      },
      /**
       * Checking if a user is a paid user
       * @return {boolean}
       */
      isPaidUser () {
        return this.userInfo.subscription.name !== 'Free'
      }
    },
    data () {
      return {
        showDatepicker: [],
        authToken: localStorage.getItem('auth_token'),
        businessSlug: localStorage.getItem('org_slug'),
        filters: {
          dateFilter: {
            label: 'All time',
            endDate: null,
            startDate: null,
            reviews_start_date: '',
            props: [
              {
                name: 'date',
                label: 'Date',
                showApplyBtn: true,
                default: { type: 'months', value: 6, selected: 'All time' }, // moment.js placeholder in type
                disabled: [],
                elements: [
                  'Last 7 days',
                  'Previous month',
                  'Last 6 months',
                  'Last 12 months',
                  'All time',
                  'Custom'
                ]
              }
            ]
          }
        }
      }
    },
    created () {
      this.getBusinessInfo()
    },
    methods: {
      /**
       * Get basic informations about business
       * @return {Promise}
       */
      getBusinessInfo () {
        return new Promise((resolve) => {
          axios.get(`business/${this.businessSlug}/info`)
          .then(({data}) => {
            this.filters.dateFilter.reviews_start_date = data.data.reviewInvite.firstInvite ? moment(data.data.reviewInvite.firstInvite.created_at).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
            resolve(data.data)
          })
          .catch((error) => {
            flash(error.message, 'is-danger')
          })
        })
      },
      isActiveTab (tab) {
        return this.openActiveTabForURL(this.$router.currentRoute.name, tab)
      },
      /**
       * Handle Date Dropdown Filter
       * @param {object} dateFilter Date data to sort on
       * @return {void}
       */
      handleDateChange (dateFilter) {
        Object.assign(this.filters.dateFilter, dateFilter)
        if (dateFilter.label === 'all_time') {
          this.filters.dateFilter.startDate = this.filters.dateFilter.reviews_start_date
          this.filters.dateFilter.endDate = moment().format('YYYY-MM-DD')
        }
        this.$emit('dateFilterChangeFromInviteLayout', this.filters.dateFilter)
      }
    }
  }
</script>

<style scoped>
  .table td, .table th {
    border: none;
  }

  .table > tbody > tr {
    background-color: #f5f5f5 !important;
    margin-bottom: 10px;
  }

  .table > tbody > td {
    margin-bottom: 20px;
  }

  tr.goto-business {
    cursor: pointer;
  }
  .tabs li.is-active a {
    color: #2aabe1 !important;
    border-bottom: 2px solid #fff;
  }
  .invite-menu {
    margin-left: 2px;
    margin-top: 25px
  }
  .tabs.is-boxed li a {
    font-size: 14px;
    font-weight: normal;
    color: rgba(88, 89, 91, 0.6);
  }
  .tabs.is-boxed li.is-active a {
    font-weight: bold;
    color: #30aae1;
  }
  .tabs.is-boxed li {
    width: 125px;
    height: 38px;
    border: solid 1px #ccc;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    background-color: #f5f5f6;
    margin-left: 4px;
    border-bottom: 0px;
  }
  .tabs.is-boxed li.is-active {
    background-color: #ffffff;
    border: solid 2px #fff;
  }
  .tabs.is-boxed li:nth-child(1){
    margin-left: 0px;
  }

  .review-invite-head {
    height: 17px;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.42;
    text-align: left;
    color: #58595b;
  }

  .top-horizontal-row {
    margin-left: -33px;
    margin-right: -26px;
  }
  .is-align-items-center {
    align-items: center;
  }
  .margin-0 {
    margin: 0;
  }
  .padding-top-0, .custom-dropdown {
    padding-top: 0;
  }
  .custom-dropdown {
    max-width: 275px;
    max-height: 37px;
  }
  >>> .button.button-dropdown img {
    height: 17px !important;
    padding: 0 !important;
  }
  .page-layout {
    margin-left: 0;
  }
  .page-layout .page-layout-head {
    color: #58595b;
    font-size: 12px;
  }
  .header-filters {
    justify-content: flex-end;
  }
  .export-button {
    width: 130px;
    height: 35px;
    color: #58595b;
    border: solid 1px #58595b;
    font-size: 11px;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/collect-reviews/ReviewInvitesLayout.vue